module.exports = __webpack_public_path__ + "static/media/box2.3d57c4e1.jpg";